"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const partners = [{
  id: 1,
  name: "DDQT",
  logo: "https://huge-sunbird.10web.cloud/wp-content/uploads/2026/04/DDQT.png?v=3uxl9r9jra5"
}, {
  id: 2,
  name: "ZPP",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587884/img/logo_zpp.png"
}, {
  id: 3,
  name: "GKV",
  logo: "https://huge-sunbird.10web.cloud/wp-content/uploads/2026/04/DDQT-Qi-gong.png?v=lgs9twbbh6e"
}, {
  id: 5,
  name: "Yoga Alliance",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1587884/img/logo_yoga_alliance.png"
}];
export default function TrustThroughExpertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    rootMargin: "0px 0px -50px 0px"
  });
  return <section data-section-id="143078" id="zertifizierungen" className="w-full bg-[#FAF6F1] py-12 border-y border-[#E0E0E0]">
      <div ref={ref} className={`mx-auto max-w-7xl px-8 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="flex flex-col lg:flex-row items-center justify-center gap-8 lg:gap-12">
          <p className="text-[#4A5D23] text-sm font-semibold uppercase tracking-widest whitespace-nowrap">
            Zertifiziert & Anerkannt:
          </p>
          
          <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12 lg:gap-16">
            {partners.map((partner, index) => <div key={partner.id} data-index={index} className="flex items-center justify-center">
                <img src={partner.logo} alt={index === 2 ? "Central Government University of India" : `${partner.name} Logo`} className="h-12 md:h-14 w-auto object-contain grayscale opacity-60 transition-all duration-500 hover:grayscale-0 hover:opacity-100 hover:scale-105" loading="lazy" />
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}